import {Component, OnInit} from '@angular/core';
import {Master} from '../../../../admin/models/master.interface';
import {KfChartsService} from '../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../models/charts-search.interface';
import {RecycleChartData} from '../../../models/recycle-chart-data.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../utils/filters-utils';


@Component({
  selector: 'app-recycle-chart',
  templateUrl: './recycle-chart.component.html',
  styleUrls: ['./recycle-chart.component.scss']
})
export class RecycleChartComponent implements OnInit {

  text = 'Recycling and recovery per collection stream';
  subtitle!: string;
  data!: RecycleChartData[];
  displayUnits = 'AVERAGE';
  years!: number[];
  collectionStreams!: Master[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.kfChartsService.getCollectionStreams().subscribe(data => this.collectionStreams = data);
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears('recycling', 'WEEE_SYSTEM_SCHEMA')
        .subscribe(data => {
          this.years = data;
          if (!search.startYear) {
            search.startYear = data[0];
          }
          if (!search.displayUnits) {
            search.displayUnits = 'AVERAGE';
          }
          this.subtitle = search.startYear + ' (EU ' + (this.displayUnits === 'WEIGHTED_AVERAGE' ? 'weighted average' : 'average') + ' %) ';
          this.kfChartsService.getRecycleByCollectionStream(search)
            .subscribe(response => {
              this.data = response;
            });
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});

    if (event.displayUnits && event.displayUnits !== '') {
      this.displayUnits = event.displayUnits;
    }
  }

}
